module.exports = __webpack_public_path__ + "static/media/shopping.2da7e4f7.svg";